<template>
  <v-dialog :value="customers.length > 0" max-width="460" @input="$emit('close')">
    <v-card data-cy="nav-customer-choice">
      <v-card-title class="text-subtitle-1">Which account for "{{ email }}"?</v-card-title>
      <v-list dense>
        <v-list-item
          v-for="customer of customers"
          :key="customer.uid"
          :data-cy="`nav-customer-${customer.uid}`"
          @click="$emit('pick', customer)"
        >
          <v-list-item-content>
            <v-list-item-title>{{ title(customer) }}</v-list-item-title>
            <v-list-item-subtitle>{{ customer.email }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-chip v-if="customer.deletedOn" small outlined>closed {{ customer.deletedOn }}</v-chip>
            <v-chip v-else small outlined color="success">open</v-chip>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-card-actions>
        <v-spacer/>
        <v-btn text @click="$emit('close')">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Asks which account an email typed in the menu's search box meant, when more than one has it:
 * open accounts first, then closed ones newest first (see rankCustomerMatches).
 */
export default {
  name: 'NavCustomerChoice',
  props: {
    email: {type: String, required: true},
    /** the ranked matches: [{uid, email, first_name, last_name, deletedOn}], empty when closed */
    customers: {type: Array, required: true},
  },
  methods: {
    title(customer) {
      return [customer.first_name, customer.last_name].filter(Boolean).join(' ') || customer.email;
    },
  },
};
</script>
